import { ampli } from 'lib-shared-tracking';
import { useCallback } from 'react';

import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import type { EditorContext } from 'flow-builder/types/context';
import type { Relation } from 'flow-builder/types/relation';

type UseNodeEditOptions = Pick<EditorContext, 'props' | 'state'>;
type UseNodeEditReturn = (node: Relation) => void;

export function useNodeEdit({
  props,
  state,
}: UseNodeEditOptions): UseNodeEditReturn {
  const {
    flow: { type },
  } = props;
  const { setSelectState } = state;

  const onEdit = useCallback<UseNodeEditReturn>(
    (node) => {
      const { nodeType } = node;

      if (nodeType === FlowNodeTypes.ACTION) {
        ampli.flowAddActionOpened({ flowType: type });
      } else {
        ampli.flowActionEditClicked({
          flowType: type,
          nodeType,
        });
      }

      setSelectState({ node });
    },
    [setSelectState, type],
  );

  return onEdit;
}
